/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shareofferover2Inputs */

const en_shareofferover2 = /** @type {(inputs: Shareofferover2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The credits offer has ended. Your links keep working.`)
};

const de_shareofferover2 = /** @type {(inputs: Shareofferover2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Credits-Aktion ist vorbei. Deine Links funktionieren weiter.`)
};

/**
* | output |
* | --- |
* | "The credits offer has ended. Your links keep working." |
*
* @param {Shareofferover2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const shareofferover2 = /** @type {((inputs?: Shareofferover2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shareofferover2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shareofferover2(inputs)
	return de_shareofferover2(inputs)
});
export { shareofferover2 as "shareOfferOver" }